import { Navigate, Outlet } from "react-router-dom";
import { Suspense } from "react";
import Landing from "./landing";
import Header from "../../layout/header";
import NotFound from "./notFound";
import UserList from "../protected/userList";

const App = () => {
  return (
    <div>
      <Suspense
        fallback={
          <div className="w-screen h-screen alignmentLogo">Any Image Here</div>
        }
      >
        <Header />
        <Outlet></Outlet>
      </Suspense>
    </div>
  );
};

export const publicRoutes = [
  {
    path: "/",
    element: <App />,
    children: [
      { path: "/", element: <UserList /> },
      { path: "*", element: <Navigate to="/not-found" /> },
    ],
  },
];
